import { AutoMap } from "@automapper/classes"
import { MPCADTO } from "./mpca.dto";

export class ProcessTechniqueDTO {
    @AutoMap()
    scolaTechnique!: string;
    @AutoMap()
    humidification!: string;
    @AutoMap()
    humidityWork!: string;
    @AutoMap()
    catchment!: string;

    @AutoMap()
    mpca!: MPCADTO;

}